<template>
    <div v-if="course.id">
        <card-header title="Responses" icon="fa-keyboard"></card-header>
        <card-body>
            <!-- <json-viewer :value="inputComponent"></json-viewer>-->
            <!-- <json-viewer :value="responses"></json-viewer>-->
            <!-- <json-viewer :value="course"></json-viewer>-->
            <!-- <json-viewer :value="enrollment.enrollment_data"></json-viewer>-->

            <card-list>
                <subheader-list-item title="Details" icon="fa-align-left" />
                <container-list-item>
                    <data-row title="Section">{{ inputComponent.section.title }}</data-row>
                    <data-row title="Component">{{ inputComponent.component.title }}</data-row>
                    <data-row title="Component Type">{{ inputComponent.component.type }}</data-row>
                    <data-row title="Input Title">
                        <span v-if="inputComponent.input.title">{{ inputComponent.input.title }}</span>
                        <span v-else>Untitled Input Block<i class="fad fa-exclamation-triangle ml-2 has-text-warning"></i></span>
                    </data-row>
                    <data-row title="Input Type">{{ inputComponent.input.type.replace('DropdownField', 'Dropdown Select Question').replace('TextArea', 'Text Area Question').replace('TextField', 'Text Field Question').replace('CheckBox', 'Checkbox/Switch') }}</data-row>
                    <data-row title="Field ID">{{ inputComponent.input.id }}</data-row>
                </container-list-item>

                <subheader-list-item title="Responses" icon="fa-comments" :badge="responses.length" />

                <card-list-item v-for="r in responses" v-if="r.length">
                    <template v-slot:icon><i class="far fa-fw fa-comment"></i></template>
                    <template v-slot:content>
                        <div class="meta">{{ r[0].value }}</div>
                    </template>
                    <template v-slot:status>
                        <div class="stats">
                            <span class="stat" v-if="!r[0].isCompleted"><i class="far fa-exclamation-triangle has-text-warning"></i></span>
                            <span class="stat" v-if="r.length > 1"><i class="far fa-triangle"></i>{{ r.length }}</span>
                        </div>
                    </template>
                    <template v-slot:details>
                        <div class="tile-details mt-4">
                            <div class="data mt-1 mb-4">
                                <data-row mini title="Enrollment">{{ r[0].enrollment_id }}</data-row>
                                <data-row mini title="Completed" v-if="!r[0].isCompleted"><i class="far fa-exclamation-triangle has-text-warning"></i> Not Complete</data-row>
                                <data-row mini title="Completed" v-else>{{ r[0].completed }}</data-row>
                                <data-row mini title="Response Changes">{{ r.length }}</data-row>
                                <data-row mini title="Field">{{ r.id }}</data-row>
                            </div>
                            <div class="data mt-1" v-for="a in r">
                                <data-row mini title="Date">{{ a.created_at | moment('MMM Do YYYY, h:mm:ss a') }}</data-row>
                                <data-row mini title="Response">{{ a.value }}</data-row>
                            </div>
                        </div>
                    </template>
                </card-list-item>

            </card-list>

        </card-body>
    </div>
</template>
<script>
    import CardHeader from "@/TIER/components/CardHeader";
    import CardToolbar from "@/TIER/components/CardToolbar";
    import CardBody from "@/TIER/components/CardBody";
    import CardList from "@/TIER/components/CardList";
    import SearchListItem from "@/TIER/components/SearchListItem";
    import NavigationListItem from "@/TIER/components/NavigationListItem";
    import SubheaderListItem from "@/TIER/components/SubheaderListItem";
    import SeparatorListItem from "@/TIER/components/SeparatorListItem";
    import ContainerListItem from "@/TIER/components/ContainerListItem";
    import DataRow from "@/TIER/components/DataRow";

    import ConferenceTile from "../../../components/tiles/ConferenceTile";

    import {client as http} from "@/http_client";
    import moment from "moment";
    import ApplicantTile from "../../../components/tiles/ApplicantTile.vue";
    import CardListItem from "../../../TIER/components/CardListItem.vue";

    export default {
        props: ['card', 'child', 'props'],
        components: {CardListItem, ApplicantTile, ConferenceTile, ContainerListItem, SeparatorListItem, DataRow, CardHeader, CardToolbar, CardBody, SearchListItem, NavigationListItem, SubheaderListItem, CardList},
        data() {
            return {
                course: {}
            };
        },
        computed: {
            inputComponent: function () {
                if (this.course.id) {
                    for (let section of this.course.course_outline) {
                        for (let component of section.sections.section_components) {
                            let content = component.components.content;

                            if (component.components.type === 'CHECKPOINT') {
                                if (content.attributes.id === this.props.inputId) {
                                    this.course.enrollments.forEach(enrollment => {
                                        enrollment.enrollment_data.forEach(data => {
                                            if (data.value && typeof data.value === 'object' && 'answer' in data.value) {
                                                data.value = data.value.answer;
                                            }
                                        });
                                    });

                                    return {
                                        section: {
                                            title: section.title
                                        },
                                        component: {
                                            title: component.components.title,
                                            type: component.components.type
                                        },
                                        input: {
                                            title: component.components.title,
                                            type: content.attributes.type,
                                            id: content.attributes.id
                                        }
                                    };


                                }
                            } else if (content.content.length) {
                                let input = content.content.find(c =>
                                    (c.component === 'DropdownField' || c.component === 'TextField' || c.component === 'TextArea' || c.component === 'CheckBox') &&
                                    c.content.id === this.props.inputId
                                );

                                if (input) {
                                    return {
                                        section: {
                                            title: section.title
                                        },
                                        component: {
                                            title: component.components.title,
                                            type: component.components.type
                                        },
                                        input: {
                                            title: input.content.title,
                                            type: input.component,
                                            id: input.content.id
                                        }
                                    };
                                }
                            }
                        }
                    }

                    console.log('No input component found');
                }
            },
            responses: function () {
                // loop through all this.course.enrollments and enrollment.enrollment_data and return the responses for this.props.inputId
                if (this.course.id) {
                    let responses = {};
                    this.course.enrollments.forEach(enrollment => {
                        // if (enrollment.completed_at) {
                        if (!responses[enrollment.id]) {
                            responses[enrollment.id] = [];
                        }
                        responses[enrollment.id] = enrollment.enrollment_data;

                        responses[enrollment.id].sort((a, b) => {
                            return new Date(b.created_at) - new Date(a.created_at);
                        });

                        responses[enrollment.id].forEach(response => {
                            response.isCompleted = moment(enrollment.completed_at).isValid();
                            response.completed = moment(enrollment.completed_at).format('MMM Do YYYY, h:mm:ss a');
                        });
                        // }

                    });

                    return responses;
                }

            }
        },
        methods: {
            loadCourse: function (force) {
                this.$emit('loading', true);
                http.get('courses/new/' + this.props.courseId + '/responses/' + this.props.inputId, {force}).then(response => {
                    this.course = response.data;
                    this.$emit('loading', false);
                });
            },
            reload: function () {
                this.loadCourse(true);
            }
        },
        watch: {
            'props.courseId': function () {
                this.loadCourse(true);
            },
            'props.inputId': function () {
                this.loadCourse(true);
            }
        },
        mounted: function () {
            this.loadCourse();
        }
    };
</script>

<style lang="scss" scoped>

    .tile-title {
        font-size: .9rem;
        font-weight: 700;
    }
</style>
